import { render, staticRenderFns } from "./OurDefendant.vue?vue&type=template&id=7470fcd4&scoped=true"
import script from "./OurDefendant.vue?vue&type=script&lang=js"
export * from "./OurDefendant.vue?vue&type=script&lang=js"
import style0 from "./OurDefendant.vue?vue&type=style&index=0&id=7470fcd4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7470fcd4",
  null
  
)

export default component.exports